import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormArray } from '@angular/forms';
import { IClientSignField } from '@app/transaction-builder/model/sign-field.model';
import { ITxFormClientData } from '@app/transaction-builder/model/transaction-form-data.model';
import { ClientDocumentRelation } from 'ngx-mat-esign360';

@Component({
  selector: 'app-document-card',
  templateUrl: './document-card.component.html',
  styleUrls: ['./document-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentCardComponent implements OnInit {
  @Input() formArray: FormArray;
  @Input() documentName: string;
  @Input() clients: ITxFormClientData[];
  @Input() signFields: IClientSignField[];
  @Input() canRemoveFile: boolean;
  @Input() canEditDocSigners: boolean;
  @Output() editSignFields = new EventEmitter<ITxFormClientData>();
  @Output() removeDocument = new EventEmitter<void>();
  @Output() documentSwap = new EventEmitter<File>();
  clientDocumentRelationEnum = ClientDocumentRelation;
  docRelationOptions = [
    ClientDocumentRelation.CannotRead,
    ClientDocumentRelation.CanRead,
    ClientDocumentRelation.MustRead,
    ClientDocumentRelation.MustSign,
  ];
  tableColumns: string[] = ['clientName'].concat(this.docRelationOptions).concat('sign-fields');
  tableDataSource = [];

  constructor() {}

  ngOnInit() {}

  compareSignerValues(a: ITxFormClientData, b: ITxFormClientData): boolean {
    return a.personalId === b.personalId;
  }

  getRadioName(client: ITxFormClientData): string {
    return `${this.documentName}${client.personalId}`;
  }

  shouldDocContainSignature(): boolean {
    return this.formArray.controls.some(
      (control) => control.value === ClientDocumentRelation.MustSign
    );
  }

  onFileChange(files: FileList) {
    if (files.length) {
      this.documentSwap.emit(files[0]);
    }
  }
}
